const defaults = [
  // Add default sidebar items here (rendered if none are provided)
];
export default defaults;
